import { http } from '@shared/api';
import type { UUID } from '@shared/api';
import type {
  Category,
  CategoryCreate,
  CategoryKind,
  CategoryUpdate,
  HsCode,
} from './types';

export const taxonomyApi = {
  listCategories: (kind?: CategoryKind) =>
    http
      .get('taxonomy/categories', { searchParams: kind ? { kind } : {} })
      .json<Category[]>(),

  createCategory: (body: CategoryCreate) =>
    http.post('taxonomy/categories', { json: body }).json<Category>(),

  updateCategory: (id: UUID, body: CategoryUpdate) =>
    http.put(`taxonomy/categories/${id}`, { json: body }).json<Category>(),

  deleteCategory: (id: UUID) => http.delete(`taxonomy/categories/${id}`).json<void>(),

  searchHsCodes: (q: string, limit = 50) =>
    http.get('taxonomy/hs-codes', { searchParams: { q, limit } }).json<HsCode[]>(),

  upsertHsCode: (body: HsCode) => http.post('taxonomy/hs-codes', { json: body }).json<HsCode>(),
};
